import React from "react";

function SvgIcMapPoi068(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 32 32" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M17.071 12.627h-1.973l-1.01-3.991 2.02-.965 1.903.965-.94 3.991zM22.008 17h1c0 2.705-1.536 6.024-3.782 7.778.037.051.085.093.112.153.23.499.01 1.096-.49 1.326 0 0-.768.398-1.285.534-.516.136-1.555.209-1.555.209-.55 0-1-.45-1-1a1 1 0 01.977-.995l.007-.003.006-.002h.01c3.247 0 5.89-4.497 5.997-7.795l.003-.205h1zm-12 0c0 2.8 1.922 6.57 4.516 7.674a1.99 1.99 0 00-.462.881C11.144 24.235 9.008 20.19 9.008 17zM16 6a2.998 2.998 0 012.974 2.632c2.301.96 3.924 2.972 4.043 5.15l.007.235h2.933a1 1 0 01.117 1.993l-.117.007h-20a1 1 0 01-.116-1.993l.116-.007h3.07c.01-2.25 1.641-4.357 3.993-5.361A3 3 0 0116 6z"
          fill="#FFF"
        />
      </g>
    </svg>
  );
}

export default SvgIcMapPoi068;
